import { defineStore } from "pinia";

export const useTranslatesStore = defineStore("translates", {
  state: () => ({
    translates: {},
  }),
  getters: {
    GET_Translates: (state) => state.translates,
  },
  actions: {
    async GET_Translate_Request(key) {
      if (this.GET_Translates[key]) return;
      const prismic = usePrismic();
      const {
        data: { value: compareImageTranslates },
      } = await useAsyncData("get_translate_" + key, () =>
        prismic.client.getSingle(key)
      );
      this.translates[key] = compareImageTranslates?.data;
    },
    async GET_All_Translations(onChangeLocale = false, prismicInstance = null) {
      const prismic = prismicInstance || usePrismic();
      // Get all translations
      const types = ["socials"];

      const promises = types.map((type) =>
        prismic.client.getSingle(type).catch((error) => {
          return { data: {} };
        })
      );
      const results = await Promise.all(promises);
      results.forEach((result, index) => {
        this.translates[types[index]] = result.data;
      });
      return results;
    },
  },
});
